import { useStatsigClient } from "@statsig/react-bindings";
import { useCallback } from "react";

const EVENT_PREFIX = "okthx::";

/**
 * Hook for logging Statsig events with the okthx:: prefix.
 * All custom events should use this hook to ensure consistent naming.
 */
export const useStatsigLogger = () => {
  const { client } = useStatsigClient();

  const logEvent = useCallback(
    (eventName: string, value?: string | number, metadata?: Record<string, string>) => {
      client.logEvent(`${EVENT_PREFIX}${eventName}`, value, metadata);
    },
    [client],
  );

  return { logEvent };
};
